import { createElement } from 'react';
import { b as __rest, aR as Toast$1, _ as __assign } from '../../index.esm-5f955dcb.js';
import 'react-measure';
import 'react-router-dom';
import 'react-dom';
import 'throttle-debounce';
import 'focus-trap-react';
import 'react-swipeable';
import 'react-animate-height';
import 'country-flag-emoji-polyfill';
import 'intersection-observer';
import 'html-react-parser';

var Toast = function Toast(_a) {
  var props = __rest(_a, ["iconBrand"]);
  return /*#__PURE__*/createElement(Toast$1, __assign({
    iconBrand: "uq-ec-"
  }, props));
};
Toast.displayName = 'Toast';

export { Toast };
